









































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { SubscriptionPackageItem } from "@/types/subscriptionPackage";
import { HttpService } from "@/services/api/httpService";
import axios, { AxiosError } from "axios";
import { ClientIdPRestriction } from "@/types/client";

@Component
export default class DashboardClientIdPRestriction extends Vue {
  httpService = new HttpService<ClientIdPRestriction>();
  responseArray = new Array<ClientIdPRestriction>();
  showModal: boolean = false;
  clientId: any = "";
  removeData = new ClientIdPRestriction();
  async getList() {
    let httpService = new HttpService<Array<ClientIdPRestriction>>();
    const response = await httpService.getList(
      `clients/${this.clientId}/identity-provider-restrictions`
    );
    this.responseArray = response.data;
    this.$emit("finishedLoading", true);
  }

  @Watch("$route", { immediate: true }) onRouteChanged() {
    this.clientId = this.$route.params.id;
    this.getList();
  }

  edit(clientIdPRestriction: ClientIdPRestriction) {
    this.$router.push({
      name: "clientIdPRestrictionEdit",
      params: {
        id: this.clientId,
        IdPRestrictionId: clientIdPRestriction.id
      }
    });
  }

  confirmRemove(data: ClientIdPRestriction) {
    this.showModal = true;
    this.removeData = data;
  }
  async remove(data: ClientIdPRestriction) {
    const response = await this.httpService.deleteItem(
      `clients/${data.clientId}/identity-provider-restrictions`,
      data.id
    );

    this.responseArray = this.responseArray.filter(
      (item: ClientIdPRestriction) => item.clientId != data.clientId,
      this.$notification.success(`${data.provider} successfully removed!`)
    );

    this.showModal = false;
    this.getList();
  }
}
